import { produce } from 'immer';

export class BaseStore {
	
	static typeDefs = ``;
	
	static updateState( GET_STORE_QUERY, draftFunction, client ){
		
		// get what is in the cache that represents this store
		let store = client.getState( GET_STORE_QUERY );
		
		// produce a new state
		let newState = produce( store, draftFunction );
		
		// write to cache
		client.writeState( newState );
		
		// return new state for use afterwards
		return newState;
		
	}
}